import React from "react"

import { withMicrocopy } from "~contexts/MicrocopyContext"
import Parameter from "./Parameter"

import * as style from "./Parameters.module.scss"

const Parameters = ({
  params, location, hideExtras, parent, explorer, microcopy,
}) => (
  <>
    {params?.[0] && (
      <section className={style.list}>
        {params.sort(prioritizeBoxVersionAndIdAndType(location)).map((param) => (
          <Parameter
            key={param.id}
            param={param}
            parent={parent}
            explorer={explorer}
            microcopy={microcopy}
            hideExtras={hideExtras}
          />
        ))}
      </section>
    )}
  </>
)

const prioritizeBoxVersionAndIdAndType = (location) => (a, b) => {
  if (location === "header") {
    if (a.key === "box-version") {
      return -1
    } else if (b.key === "box-version") {
      return 1
    }
  }

  if (a.key === "id") {
    return -1
  } else if (b.key === "id") {
    return 1
  } else if (a.key === "type" && b.key !== "id") {
    return -1
  } else if (b.key === "type" && a.key !== "id") {
    return 1
  } return 0
}

export default withMicrocopy(Parameters)
